import LegalPage from "./LegalPage";
const Privacy = () => <LegalPage docKey="privacy" />;
export default Privacy;
